import { SxProps } from '@mui/material';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { FC } from 'react';
import { sxs } from '@utils/mui/sx';

const defaultTooltipSx: SxProps = {
    bgcolor: 'grey.300',
    maxWidth: 'none',
    minWidth: '336px',
    p: 2,
};

const defaultArrowSx: SxProps = {
    '&::before': {
        bgcolor: 'grey.300',
    },
    color: 'grey.300',
};

interface InfoTooltipProps
    extends Pick<
        TooltipProps,
        | 'children'
        | 'disableFocusListener'
        | 'leaveDelay'
        | 'onClose'
        | 'onOpen'
        | 'open'
        | 'placement'
        | 'sx'
        | 'title'
    > {
    arrowSx?: SxProps;
    offset?: [number, number];
    tooltipSx?: SxProps;
}

const InfoTooltip: FC<InfoTooltipProps> = ({
    arrowSx = {},
    children,
    disableFocusListener,
    leaveDelay = 100,
    offset = [0, 0],
    onClose,
    onOpen,
    open,
    placement = 'top-start',
    sx = {},
    title,
    tooltipSx = {},
}) => (
    <Tooltip
        disableFocusListener={disableFocusListener}
        leaveDelay={leaveDelay}
        onClose={onClose}
        onOpen={onOpen}
        open={open}
        placement={placement}
        slotProps={{
            arrow: { sx: sxs([defaultArrowSx, arrowSx]) },
            popper: {
                modifiers: [
                    { enabled: true, name: 'flip' },
                    {
                        enabled: true,
                        name: 'offset',
                        options: { offset },
                    },
                    {
                        enabled: true,
                        name: 'preventOverflow',
                        options: {
                            altAxis: true,
                            boundary: 'viewport',
                            padding: 8,
                            rootBoundary: 'viewport',
                        },
                    },
                ],
                popperOptions: {
                    strategy: 'fixed',
                },
            },
            tooltip: { sx: sxs([defaultTooltipSx, tooltipSx]) },
        }}
        sx={sx}
        title={title}
        arrow
    >
        {children}
    </Tooltip>
);

export default InfoTooltip;
